module.exports = __webpack_public_path__ + "img/Group-603.fd66798a.png";